var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-side",staticStyle:{"border":"0px solid red","width":"100%","height":"100%"}},[_c('row',[_c('div',{staticStyle:{"text-align":"center","font-size":"xx-large"}},[_c('div',{staticClass:"logo-lg"},[_c('img',{staticClass:"resize",attrs:{"src":_vm.img_url.img_no_permission}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f75d9e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommingSoon/CommingSoon.vue
// module id = null
// module chunks = 